import { StyleSheet } from 'aphrodite';

import {
  auroMetalSaurus,
  backgroundGrey5,
  borderGray,
  contentVerifiedBlue,
  darkOrange,
  positiveGreen,
  shadowVeryLight,
  squidInk,
  warmGray,
  white,
} from 'lib/css/colors';

const sharedStyles = StyleSheet.create({
  fieldLabel: {
    color: auroMetalSaurus,
    fontSize: '0.7rem',
    fontWeight: 700,
    letterSpacing: 0.8,
    marginBottom: 6,
    textTransform: 'uppercase',
  },
  fieldLabelHint: {
    color: warmGray,
    fontWeight: 400,
    textTransform: 'none',
    letterSpacing: 0,
  },
  fieldLabelWarning: {
    color: darkOrange,
    fontWeight: 600,
    textTransform: 'none',
    letterSpacing: 0,
  },
  textInput: {
    border: `1px solid ${borderGray}`,
    borderRadius: 6,
    fontSize: '0.95rem',
    padding: '8px 12px',
  },
  boldInput: {
    fontWeight: 700,
  },
  urlLabelRow: {
    display: 'flex',
    alignItems: 'baseline',
    marginBottom: 6,
  },
  urlOpenIcon: {
    marginLeft: 6,
    color: auroMetalSaurus,
    fontSize: '0.85rem',
    ':hover': {
      color: squidInk,
    },
  },
  urlInputWrapper: {
    position: 'relative',
  },
  urlInputIcon: {
    position: 'absolute',
    top: '50%',
    left: 10,
    transform: 'translateY(-50%)',
    color: auroMetalSaurus,
    pointerEvents: 'none',
  },
  urlInput: {
    paddingLeft: 32,
    paddingRight: 32,
  },
  card: {
    backgroundColor: white,
    border: `1px solid ${borderGray}`,
    borderRadius: 12,
    boxShadow: `0 1px 3px ${shadowVeryLight}`,
  },
  cardTopRow: {
    borderBottom: `1px solid ${backgroundGrey5}`,
  },
  cardActionBar: {
    borderTop: `1px solid ${backgroundGrey5}`,
    paddingTop: 16,
  },
  heading: {
    fontSize: '1.25rem',
    fontWeight: 800,
    color: squidInk,
    letterSpacing: 0.5,
  },
  idLink: {
    color: contentVerifiedBlue,
    fontSize: '0.85rem',
    fontWeight: 600,
    textDecoration: 'underline',
    ':hover': {
      color: squidInk,
      textDecoration: 'underline',
    },
  },
  primaryGreenButton: {
    fontWeight: 600,
    borderRadius: 6,
    backgroundColor: positiveGreen,
    border: 'none',
    ':hover': {
      backgroundColor: positiveGreen,
      opacity: 0.9,
    },
  },
});

export default sharedStyles;
